<template>
  <el-card>
    <el-descriptions>
      <el-descriptions-item :span="3" :label="$t('编号')">{{ noticeInfo.num || "" }}</el-descriptions-item>
      <el-descriptions-item :span="3" :label="$t('公告标题')">{{ noticeInfo.title || "" }}</el-descriptions-item>
      <el-descriptions-item :span="3" :label="$t('公告内容')">
        <div class="content" v-html="noticeInfo.content"></div>
      </el-descriptions-item>
      <el-descriptions-item :span="1" :label="$t('发布时间')">{{ noticeInfo.releaseTime | formatDate }}</el-descriptions-item>
      <el-descriptions-item :span="1" :label="$t('公告状态')">{{$t(NOTICE_STATUS.getLabelByValue(noticeInfo.status))}}</el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import {NOTICE_STATUS} from "@/constant/constant";

export default {
  name: "NoticeDetail",
  data() {
    return {
      noticeInfo: {},
      NOTICE_STATUS
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await request(this.$api.notice.detail, this.$route.query);
        this.noticeInfo = res.notice;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.content {
  width: 50%;
  height: 500px;
  overflow-y: auto;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #dddddd;
}

</style>
